import { initializeApp } from 'firebase/app'
import { getAnalytics, logEvent, setUserId } from 'firebase/analytics'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
import { useEffect } from 'react'
import { putWithAuth } from '@/api/httpRequests'
import { useAppStore } from '@/shared/store'

const useFirebaseAnalytics = () => {
    const firebaseConfig = {
        apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
        authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
        storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_FIREBASE_APP_ID,
        measurementId: process.env.REACT_APP_GET_GA_ID,
    }
    const { isCookiesAccepted } = useAppStore()
    const app = initializeApp(firebaseConfig)
    const analytics = getAnalytics(app)
    const messaging = getMessaging(app)
    const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY
    let FMCToken: string

    const userId = 'USER_ID'

    const analyticsLogEvent = (
        eventName: string,
        eventParams?: Record<string, unknown>
    ) => {
        if (eventParams) return logEvent(analytics, eventName, eventParams)
        return logEvent(analytics, eventName)
    }

    useEffect(() => {
        if (!isCookiesAccepted) return

        if ('Notification' in window) {
            setUserId(analytics, userId)
            if (Notification.permission === 'default') {
                Notification.requestPermission().then((permission) => {
                    if (permission === 'granted') {
                        console.log('Notification permission granted.')
                        getToken(messaging, {
                            vapidKey,
                        })
                            .then((currentToken: string) => {
                                if (currentToken) {
                                    FMCToken = currentToken
                                    const registrationTokenBody =
                                        JSON.stringify({
                                            registrationToken: FMCToken,
                                        })
                                    const response = putWithAuth(
                                        'PUT',
                                        true,
                                        registrationTokenBody
                                    )
                                    console.log(response) //should return status 200
                                } else {
                                    console.log(
                                        'No registration token available. Request permission to generate one.'
                                    )
                                }
                            })
                            .catch((err) => {
                                console.log(
                                    'An error occurred while retrieving token. ',
                                    err
                                )
                            })
                    } else {
                        console.log('Notification permission denied.')
                    }
                })
            } else if (Notification.permission === 'denied') {
                console.log(
                    'Notifications are blocked. Please unblock them in your browser settings.'
                )
            }
        }
    }, [userId, messaging, vapidKey, isCookiesAccepted])

    onMessage(messaging, (payload) => {
        console.log('Message received. ', payload)
    })
    return { analyticsLogEvent, onMessage }
}

export { useFirebaseAnalytics }
